let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8pGOz")).then(() => parcelRequire('2d1CS'));